var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[(_vm.pageInfo.footCopyrightState == 1)?_c('div',{staticClass:"footer-txt"},[_vm._v(" "+_vm._s(_vm.pageInfo.footCopyright)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }